export default __webpack_public_path__ + "static/Hooker-Valley-track-credit-Andrea-Schaffer-53f5b1fc3abbe40c1720166a7a8e2153.jpg";